import { Cache as ViteCache } from "../Cache";
const Cache = ViteCache;

export interface Caching {
	readonly name: string;
	getValue(callable: () => Promise<string>): Promise<string>
	getStatusUpdate(): string;
}

export class Cached_Message implements Caching {
	
	constructor(readonly name: string) {}
	
	async getValue(callable: () => Promise<string>): Promise<string> {
		const cache = Cache.get(this.name);
		if (cache) {
			return cache;
		}
		const content = await callable();
		Cache.set(this.name, content);
		return content;
	}

	getStatusUpdate(): string {
		if( Cache.get(this.name) ) {
			return `[${this.name}] cache: HIT`;
		}
		return `[${this.name}] cache: MISS`;
	}
	
}

export class Uncached_Message implements Caching {
	
	constructor(readonly name: string) {}
	
	async getValue(callable: () => Promise<string>): Promise<string> {
		return await callable();
	}

	getStatusUpdate(): string {
		return `[${this.name}] cache: NONE`;
	}
	
}